<div class="aza-cart-v2-order-items-title">
  <ng-content select="[aza-cart-v2-order-items-table-view-title]"></ng-content>
</div>
<div class="aza-cart-v2-order-items-table-view-order-items-container">
  <div class="aza-cart-v2-order-items-table-view-header-cell">
    <span translate>DATE</span>
  </div>
  <div class="aza-cart-v2-order-items-table-view-header-cell justify-content-end">
    <span translate>QTY</span>
  </div>
  <div class="aza-cart-v2-order-items-table-view-header-cell">
    <span translate>PRODUCT</span>
  </div>
  <div class="aza-cart-v2-order-items-table-view-header-cell justify-content-end">
    <span translate>UNIT_PRICE</span>
  </div>
  <div class="aza-cart-v2-order-items-table-view-header-cell justify-content-end">
    <span translate>DISCOUNT</span>
  </div>
  <div class="aza-cart-v2-order-items-table-view-header-cell justify-content-end">
    <span translate>TAX</span>
  </div>
  <div
    class="aza-cart-v2-order-items-table-view-header-cell aza-cart-v2-order-items-table-view-last-header-cell justify-content-end">
    <span translate>SUBTOTAL</span>
  </div>
  @for (item of orderItems; track getOrderItemTrackByValue(item, $index)) {
    <div class="aza-cart-v2-order-items-table-view-cell">
      <span>{{item.transaction_date | eventDate}}</span>
    </div>
    <div class="aza-cart-v2-order-items-table-view-cell justify-content-end">
      <span>{{item.quantity}}</span>
    </div>
    <div class="aza-cart-v2-order-items-table-view-cell">
      <span>{{item.product_name}}</span>
    </div>
    <div class="aza-cart-v2-order-items-table-view-cell justify-content-end">
      <span>{{item.unit_price | twoDecNumber | addText:cartCurrency}}</span>
    </div>
    <div class="aza-cart-v2-order-items-table-view-cell justify-content-end">
      <span>{{item.discount | twoDecNumber | addText:cartCurrency}}</span>
    </div>
    <div class="aza-cart-v2-order-items-table-view-cell justify-content-end">
      <span>{{item.tax | twoDecNumber | addText:cartCurrency}}</span>
    </div>
    <div
      class="aza-cart-v2-order-items-table-view-cell aza-cart-v2-order-items-table-view-last-cell justify-content-end">
      <span>{{item.total | twoDecNumber | addText:cartCurrency}}</span>
    </div>
  }
  <div
    class="aza-cart-v2-order-items-table-view-cell aza-cart-v2-order-items-table-view-to-pay-refund-label-container aza-cart-v2-order-items-to-pay-refund-label-container">
    @if (orderTotal < 0) {
      <span class="aza-cart-v2-order-items-refund-label" translate>REFUND</span>
    }
    @if (orderTotal >= 0) {
      <span class="aza-cart-v2-order-items-to-pay-label" translate>TO_PAY</span>
    }
  </div>
  <div
    class="aza-cart-v2-order-items-table-view-to-pay-refund-value-container aza-cart-v2-order-items-table-view-cell aza-cart-v2-order-items-table-view-last-cell justify-content-end aza-horizontal-stack aza-vertical-items-centered">
    @if (orderTotal < 0) {
      <span class="aza-cart-v2-order-items-refund-value">{{-orderTotal | twoDecNumber}}</span>
      <span> {{cartCurrency}}</span>
    }
    @if (orderTotal >= 0) {
      <span class="aza-cart-v2-order-items-to-pay-value">{{orderTotal | twoDecNumber}}</span>
      <span> {{cartCurrency}}</span>
    }
  </div>
</div>
